import { render, staticRenderFns } from "./HeaderCrumbs.vue?vue&type=template&id=2902ac75&scoped=true"
import script from "./HeaderCrumbs.vue?vue&type=script&lang=js"
export * from "./HeaderCrumbs.vue?vue&type=script&lang=js"
import style0 from "./HeaderCrumbs.vue?vue&type=style&index=0&id=2902ac75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2902ac75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2902ac75')) {
      api.createRecord('2902ac75', component.options)
    } else {
      api.reload('2902ac75', component.options)
    }
    module.hot.accept("./HeaderCrumbs.vue?vue&type=template&id=2902ac75&scoped=true", function () {
      api.rerender('2902ac75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderCrumbs.vue"
export default component.exports